export default "__VITE_ASSET__vWu_MQF___"